import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "description", "disabled", "disabledTooltipTitle", "illustrationName", "input", "title", "titleAction"];
import { Fragment, cloneElement } from 'react';
import useUniqueId from 'react-utils/hooks/useUniqueId';
import PropTypes from 'prop-types';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Small } from 'foundations-components/transitional/components/Small';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import SettingsRowLayout from './SettingsRowLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * SettingsRowCheckbox variation of SettingsRow handles toggle/checkbox-type settings.
 */
const SettingsRowCheckbox = _ref => {
  let {
      className,
      description,
      disabled,
      disabledTooltipTitle,
      illustrationName,
      input,
      title,
      titleAction
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const inputId = useUniqueId('SettingsRowCheckbox-input-');
  const labelId = useUniqueId('SettingsRowCheckbox-label-');
  if (!input) return null;
  const cloneProps = {
    id: inputId,
    'aria-labelledby': labelId
  };
  if (disabled) {
    cloneProps.disabled = true;
  }
  const decoratedInput = /*#__PURE__*/cloneElement(input, cloneProps);
  const renderedTitle = /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      title: disabledTooltipTitle,
      disabled: !disabled || !disabledTooltipTitle,
      children: /*#__PURE__*/_jsx(FormLabel, {
        htmlFor: inputId,
        paddingBlock: "0 !important",
        children: title
      })
    }), titleAction]
  });
  const renderedInput = /*#__PURE__*/_jsx(Tooltip, {
    title: disabledTooltipTitle,
    disabled: !disabled || !disabledTooltipTitle,
    children: decoratedInput
  });
  const renderedDescription = description && /*#__PURE__*/_jsx(Small, {
    display: "block",
    use: "help",
    children: description
  });
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(SettingsRowLayout, Object.assign({
      className: className,
      input: renderedInput,
      illustrationName: illustrationName,
      title: renderedTitle,
      description: renderedDescription
    }, rest))
  );
};
SettingsRowCheckbox.propTypes = {
  className: PropTypes.string,
  /**
   * Description for this setting.
   */
  description: PropTypes.node,
  /**
   * If this setting or action is turned off.
   */
  disabled: PropTypes.bool,
  /**
   * Content in disabled tooltip.
   */
  disabledTooltipTitle: PropTypes.node,
  /**
   * SettingsRowLogo or SettingsRowIllustration instance for visuals on the row.
   */
  illustration: PropTypes.node,
  /**
   * In-progress Deprecation: Illustration or logo name to render.
   */
  illustrationName: PropTypes.string,
  /**
   * UICheckbox or UIToggle to render for settings state.
   */
  input: PropTypes.node.isRequired,
  /**
   * Text for the setting title.
   */
  title: PropTypes.node.isRequired,
  /**
   * Clickable action text placed next to the setting title.
   */
  titleAction: PropTypes.node
};
export default SettingsRowCheckbox;